import { render, staticRenderFns } from "./MyProfilesPage.vue?vue&type=template&id=067ebaf1"
import script from "./MyProfilesPage.vue?vue&type=script&lang=js"
export * from "./MyProfilesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports